<template>
  <ion-page>
    <ion-content fullscreen>
        <ion-grid>
            <!-- <ion-row class="dashboard-row">
                <ion-col size="12" size-md="4">
                    <ion-card button @click="AddCPOUser" class="dashboard-card">
                        <ion-card-content>
                            <ion-icon :icon="personAddOutline" class="dash-icon"></ion-icon>
                            <h2>User Creation</h2>
                            <p>Create and manage CPO users</p>
                        </ion-card-content>
                    </ion-card>
                </ion-col>
                <ion-col size="12" size-md="4">
                    <ion-card button @click="AddReport" class="dashboard-card">
                        <ion-card-content>
                            <ion-icon :icon="barChartOutline" class="dash-icon"></ion-icon>
                            <h2>Reports</h2>
                            <p>View and Download reports</p>
                        </ion-card-content>
                    </ion-card>
                </ion-col>
                <ion-col size="12" size-md="4">
                    <ion-card button @click="AddUserWallet" class="dashboard-card">
                        <ion-card-content>
                            <ion-icon :icon="pricetagOutline" class="dash-icon"></ion-icon>
                            <h2>User Wallet</h2>
                            <p>Manage user wallet balance and transactions</p>
                        </ion-card-content>
                    </ion-card>
                </ion-col>
            </ion-row> -->
            <ion-row class="dashboard-row">
              <ion-col
                v-for="item in this.adminList"
                :key="item.visibilityId"
                size="12"
                size-md="4"
              >
                <ion-card
                  button
                  @click="adminClick(item)"
                  class="dashboard-card"
                >
                  <ion-card-content>
                    <ion-icon
                      :icon="item.icon"
                      class="dash-icon"
                    ></ion-icon>

                    <h2>{{ item.name }}</h2>
                    <p>{{ item.description }}</p>
                  </ion-card-content>
                </ion-card>
              </ion-col>
            </ion-row>
        </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import { defineComponent } from "vue";
import { IonPage, IonContent, IonGrid, IonRow, IonCol, IonCard, IonCardContent, IonIcon } from "@ionic/vue";
import { businessOutline, personAddOutline, pricetagOutline, barChartOutline } from "ionicons/icons";
import { CorporateService } from "../../service/corporate/corporate.service";

export default defineComponent({
  name: "Dashboard",
  components: {
    IonPage,
    IonContent,
    IonGrid,
    IonRow,
    IonCol,
    IonCard,
    IonCardContent,
    IonIcon
  },
  data() {
    return {
      businessOutline,
      personAddOutline,
      pricetagOutline,
      barChartOutline,
      adminList: [],
      iconMap: {
        personAddOutline,
        barChartOutline,
        pricetagOutline
      }
    };
  },
  async mounted() {
    let response = await new CorporateService().getAdminionList();
    this.adminList = response.data.map(item => ({
      ...item,
      icon: this.iconMap[item.icon]
    }));
  },
  methods: {
    AddCorporateName() {
      this.$router.push("CorporateNameList");
    },
    AddCPOUser() {
      this.$router.push("CPOUserCreation");
    },
    AddUserWallet() {
      this.$router.push("manageUsers");
    },
    AddReport() {
        this.$router.push("viewAllReports");
    },
    adminClick(item) {
      this.$router.push(item.path);
    },
  }
});
</script>

<style scoped>
.dashboard-row {
  margin-top: 50px;
}

.dashboard-card {
  cursor: pointer;
  text-align: center;
  border-radius: 18px;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.dashboard-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 26px rgba(0, 0, 0, 0.2);
}

.dash-icon {
  font-size: 34px;
  color: #099c14;
  margin-bottom: 12px;
}

h2 {
  font-size: 18px;
  font-weight: 600;
  margin: 6px 0;
}

p {
  font-size: 12px;
  color: #666;
}

@media (max-width: 768px) {
  .dashboard-card {
    margin-bottom: 16px;
  }
}
</style>
